<template>
    <div>
        <div class="treetitle">
            <div class="tree-header-left">
                <img src="../assets/icon_level.svg" style="height:15px;vertical-align:middle"/><span v-t="'message.item_layerId'"></span>
                <img src="../assets/user.svg" style="padding-left:10px;height:15px;vertical-align:middle"/>
                <span v-t="'message.item_userId_displayName_tenantName'"></span>
                <img src="../assets/group.svg" style="padding-left:10px;height:18px;vertical-align:middle"/><span v-t="'message.item_groupId'"></span>
            </div>
        </div>
        <div v-if="FEATURE_JKC_TRACKING_WITH_STATUS" class="tree-controls">
            <span class="tree-controls-label">表示変更</span>
            <el-switch
                v-model="expansionView"
                active-color="#5171cb"
                @change="handleExpansionView">
            </el-switch>
        </div>
        <el-tree v-if="show"
            class="common-object-tree"
            :props="properties"
            :load="loadNode"
            node-key="name"
            ref="tree"
            lazy
            highlight-current
            :default-expanded-keys="initialGroup.nodeList"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :render-content="renderContent">
        </el-tree>
   </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

import {FEATURE_JKC_TRACKING_WITH_STATUS} from "@/components/feature_toggles/feature_toggle";

export default {
    data() {
        return {
            show: false,
            loadingScreen: null,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf',
            },
            initialGroup: {
                fullPath: null,
                nodeList: [],
                groupName: null,
            },
            expansionView: false,
        };
    },
    props: {
        initialData: Object,
        userPresences: Object,
    },
    computed: {
        FEATURE_JKC_TRACKING_WITH_STATUS() {
            return FEATURE_JKC_TRACKING_WITH_STATUS;
        }
    },
    methods: {
        handleNodeClick(data, node, elNode) {
            if(node.data.type == constants.OBJECT_TALKGROUP) {
                if (node.childNodes.length == 0) {
                    this.loadingScreen = this.$loading({
                            lock: true ,
                            text: 'Loading data ...' ,
                            spinner: 'el-icon-loading' ,
                            background: 'rgba(0, 0, 0, 0)'
                    });
                    let self = this;
                    let userDataList = [];
                    server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                    .then((res) => {
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                                break;
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleNodeClick").replace("{code}",res.data.status));
                                break;
                        }
                        if (data.length == 0) {
                            node.loading = true;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        } else {
                            for (let index = 0 ; index < userDataList.length ; index ++) {
                                if (index == 0) {
                                    self.$refs.tree.append(userDataList[index], node);
                                } else {
                                    self.$refs.tree.insertAfter(userDataList[index], node.childNodes[index -1]);
                                }
                            }
                        }
                        self.closeLoadingScreen();
                        self.$emit('on-selectnode', elNode)
                    })
                    .catch( function ( error ) {
                        self.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(self, "handleNodeClick", error);
                    });
                } else {
                    this.$emit('on-selectnode', elNode)
                }
            } else {
                this.$emit('on-selectnode', elNode)
            }
        },
        reload() {
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
                if (this.expansionView) {
                    this.$nextTick(() => {
                        const rootData = this.initialData[0];
                        const rootNode = this.$refs.tree?.getNode(rootData?.name);
                        if (rootNode) {
                            this.$refs.tree.setCurrentKey(rootData.name);
                            this.$emit('on-selectnode', {node: rootNode});
                        }
                    });
                }
            });
        },
        async loadNode(node, resolve) {
            if (!node.parent && this.initialData.length) {
                resolve(this.expansionView ? this.initialData.slice(0, 1) : this.initialData);
                return;
            }

            this.loadingScreen = this.$loading({
                lock: true,
                text: 'Loading data ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)',
            });

            switch(node.data.type) {
                case constants.OBJECT_NODE:
                    const payload = {
                        tenantId: node.data.tenantId,
                        parentId: node.data.id,
                        type: -1,
                        c2cPermissionType: constants.C2C_PERMISSION_TYPE.TRACKING,
                    };
                    try {
                        const res = await server.post('/getchildren', payload);
                        if (res.data.status >= constants.STATUS_SUCCESS) {
                            const data = [];
                            for (const nodeInfo of res.data.nodeInfo) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: nodeInfo.id,
                                    name: nodeInfo.name,
                                    label: nodeInfo.name,
                                    type: nodeInfo.type,
                                    isLeaf: nodeInfo.hasChild === 0
                                });
                            }
                            if(this.expansionView){
                                // ユーザー表示(動態管理拡張)
                                for (let i = 0; i < res.data.userInfos.length; i++) {
                                    if (!this.showAdminUser &&
                                        res.data.userInfos[i].restrictions != null &&
                                        res.data.userInfos[i].restrictions.includes(constants.RESTRICTION_LOGIN)
                                    ) {
                                        continue;
                                    }

                                    data.push({
                                        tenantId: node.data.tenantId,
                                        id: res.data.userInfos[i].userId,
                                        name: res.data.userInfos[i].userName,
                                        displayName: res.data.userInfos[i].displayName,
                                        label: res.data.userInfos[i].userName + " / " + res.data.userInfos[i].displayName,
                                        type: constants.OBJECT_USER,
                                        restrictions: res.data.userInfos[i].restrictions,
                                        isLeaf: true,
                                        trackingOption: ((res.data.userInfos[i].optionFlag & commonUtil.bitShiftUserOption(constants.USER_OPTION_TRACKING)) != 0),
                                        status: ""
                                    });

                                    data.sort(function(e1, e2) {
                                        if (e1.type < e2.type) return -1;
                                        else if (e1.type > e2.type) return 1;
                                        else if (e1.trackingOption !== e2.trackingOption) return e1.trackingOption ? -1 : 1;
                                        else {
                                            let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                            if (comparisonResult < 0) return -1;
                                            else if (comparisonResult > 0) return 1;
                                        }
                                        return 0;
                                    });
                                }
                                //無線機表示
                                const ipRadioInfos = res.data.ipRadioInfos || [];
                                for (let i = 0; i < ipRadioInfos.length; i++) {
                                    if (!this.showAdminUser &&
                                        ipRadioInfos[i].restrictions != null &&
                                        ipRadioInfos[i].restrictions.includes(constants.RESTRICTION_LOGIN)
                                    ) {
                                        continue;
                                    }

                                    data.push({
                                        tenantId: node.data.tenantId,
                                        id: ipRadioInfos[i].userId,
                                        name: ipRadioInfos[i].userName,
                                        displayName: ipRadioInfos[i].displayName,
                                        label: ipRadioInfos[i].userName + " / " + ipRadioInfos[i].displayName,
                                        type: constants.OBJECT_IP_RADIO,
                                        restrictions: ipRadioInfos[i].restrictions,
                                        isLeaf: true,
                                        trackingOption: ((ipRadioInfos[i].optionFlag & commonUtil.bitShiftUserOption(constants.USER_OPTION_TRACKING)) != 0),
                                        status: ""
                                    });

                                    data.sort(function(e1, e2) {
                                        if (e1.type != 0 && e2.type != 0){
                                            if (e1.trackingOption !== e2.trackingOption) return e1.trackingOption ? -1 : 1;
                                        }
                                        if (e1.type < e2.type) return -1;
                                        else if (e1.type > e2.type) return 1;
                                        else {
                                            let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                            if (comparisonResult < 0) return -1;
                                            else if (comparisonResult > 0) return 1;
                                        }
                                        return 0;
                                    });
                                }

                            }else{
                                // グループ表示
                                for (const talkGroupInfo of res.data.talkGroupInfos) {
                                    data.push({
                                        tenantId: node.data.tenantId,
                                        id: talkGroupInfo.talkgroupId,
                                        name: talkGroupInfo.talkgroupName,
                                        label: talkGroupInfo.talkgroupName,
                                        type: constants.OBJECT_TALKGROUP,
                                        isLeaf: false
                                    });
                                }

                                data.sort((e1, e2) =>{
                                    if (e1.type < e2.type) {return -1;
                                    } else if (e1.type > e2.type) {return 1;
                                    }else {
                                        const comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                        if (comparisonResult < 0) {return -1;
                                        } else if (comparisonResult > 0) {
                                        return 1;
                                    }
                                    }
                                    return 0;
                                });
                            }
                            resolve(data)
                            if (this.initialGroup && !this.initGroupSelected && !this.expansionView) {
                                this.checkInitialDisplayGroup(data);
                            }
                        } else {
                            switch (res.data.status) {
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_expand_layer_denied"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "loadNode-2").replace("{code}", res.data.status));
                                    break;
                            }
                            node.loading = false;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        }
                        this.closeLoadingScreen();
                    } catch (e) {
                        commonUtil.putExceptionErrorMessage(this, "loadNode", e);
                        this.closeLoadingScreen();
                    }
                    return;
                case constants.OBJECT_TALKGROUP:
                    try {
                        const res = await server.post('/gettalkerlist', {
                            tenantId: node.data.tenantId,
                            talkgroupId: node.data.id
                        });
                        if (res.data.status >= constants.STATUS_SUCCESS) {
                            resolve(this.getTalkerListNodeData(res.data.nodeInfo));
                        } else {
                            switch(res.data.status) {
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_expand_layer_denied"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "loadNode-1").replace("{code}", res.data.status));
                                    break;
                            }
                            node.loading = false;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        }
                        this.closeLoadingScreen();
                    } catch (e) {
                        this.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(this, "loadNode", e);
                    }
                    return;
            }
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            switch (data.type) {
                case constants.OBJECT_NODE:
                    if (data.id == 1) {
                        objectIcon = require("../assets/icon_tenant.svg");
                    } else {
                        objectIcon = require("../assets/icon_level.svg");
                    }
                    break;
                case constants.OBJECT_USER:
                    if(this.expansionView){
                        if(data.trackingOption){
                            const userPresence = this.getUserPresence(data.id, this.userPresences);
                            if(userPresence != undefined){
                                objectIcon = require("../assets/icon_expansion/icon_user_online.png");
                                data.status = userPresence.userStatus;
                            }else{
                                objectIcon = require("../assets/icon_expansion/icon_user_offline.png");
                                data.status = "";
                            }
                        }else{
                            objectIcon = require("../assets/icon_expansion/icon_user_invalid.png");
                        }
                    }else{
                        objectIcon = require("../assets/user.svg");
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                    objectIcon = require("../assets/group.svg");
                    break;
                case constants.OBJECT_IP_RADIO:
                    if (this.expansionView) {
                        if (data.trackingOption) {
                            const userPresence = this.getUserPresence(data.id, this.userPresences);
                            if (userPresence != undefined) {
                                if (userPresence.isOnline) {
                                    if (userPresence.isEmergency) {
                                        objectIcon = require("../assets/icon_expansion/icon_ipRadio_emergency.png");
                                        data.status = userPresence.userStatus;
                                        this.$emit('emergencyActivation', data.id, data.name);
                                        break;
                                    }

                                    objectIcon = require("../assets/icon_expansion/icon_ipRadio_online.png");
                                    data.status = userPresence.isStun ?
                                        data.status = commonUtil.getMessageText(this.$i18n, "item_ip_radio_Info_stun") :
                                        userPresence.userStatus;
                                } else {
                                    objectIcon = require("../assets/icon_expansion/icon_ipRadio_offline.png");
                                    data.status = "";
                                }
                            } else {
                                objectIcon = require("../assets/icon_expansion/icon_ipRadio_offline.png");
                                data.status = "";
                            }
                        } else {
                            objectIcon = require("../assets/icon_expansion/icon_ipRadio_invalid.png");
                            data.status = "";
                        }
                    } else {
                        objectIcon = require("../assets/IP_Radio/ip_radio_icon.png");
                    }
                    break;
            }
            return h("span",{class:"tree-item"},[
              h("img",{attrs:{src:objectIcon,height:"20px",style:"vertical-align: middle"}}),
              h("span",{class:"tree-text"},[
                h("span",{class:"tree-name"},node.label),
                ...(data.status && String(data.status).length>0 ? [h("br"), h("span",{class:"tree-status"},`[${data.status}]`)] : [])
              ])
            ]);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        getTalkerListNodeData(nodeData) {
            const getTenantName = (tenantId) => {
                const tenantName = this.initialData.find(t => t.tenantId === tenantId)?.name ?? "";
                return tenantName === "ROOT-NODE" ? "" : tenantName;
            };

            return nodeData.map((node) => {
                const tenantName = getTenantName(node.tenantId);
                return {
                    tenantId: node.tenantId,
                    id: node.id,
                    name: node.name,
                    label: tenantName
                        ? `${node.name} / ${node.displayName} / ${tenantName}`
                        : `${node.name} / ${node.displayName}`,
                    type: node.type,
                    markerIcon: node.markerIcon,
                    displayName: node.displayName,
                    isLeaf: true
                };
            }).toSorted((e1, e2) => {
                if (e1.type < e2.type) {
                    return -1;
                } else if (e1.type > e2.type) {
                    return 1;
                } else {
                    const comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                    if (comparisonResult < 0) {
                        return -1;
                    } else if (comparisonResult > 0) {
                        return 1;
                    }
                }
                return 0;
            });
        },
        checkInitialDisplayGroup(dataList) {
            for (let data of dataList) {
                if (data.type == constants.OBJECT_TALKGROUP) {
                    if (data.label == this.initialGroup.groupName) {
                        this.initGroupSelected = true;
                        this.$refs.tree.setCurrentKey(data.name);
                        this.$emit('onInitGroup', this.$refs.tree.getNode(data.name));
                    }
                }
            }
        },
        handleExpansionView(val) {
            this.$emit('expansionChange', val);
            this.reload();
        },
        getUserPresence(userId, userPresences) {
            if (userPresences == null) return undefined;

            const userPresence = userPresences[userId];
            if (userPresence === undefined) return undefined;

            return {
                userStatus: userPresence.status,
                isOnline: userPresence.isOnline,
                isEmergency: userPresence.isEmergency,
                isStun: userPresence.isStun
            };
        },
        clickedEmergency(userName){
            if(!this.expansionView){
                this.expansionView = true;
                this.handleExpansionView(this.expansionView);
                this.$nextTick(() => {});
            //     handleExpansionViewに続くreload終了後にちゃんとselectByUserNameが動くように修正する。
            }
            this.selectByUserName(userName);
        },
        selectByUserName(userName) {
            const tree = this.$refs.tree;
            const targetNode = tree.getNode(userName);
            const targetData = targetNode.data;
            const targetElNode = targetNode;
            targetElNode.node = targetNode;
            if(targetNode && targetData &&targetElNode){
                tree.setCurrentKey(userName);
                this.handleNodeClick(targetData, targetNode, targetElNode);
            }
        },
        generate64bitHash(top, end) {
            // topをBigIntに変換し、32ビット左シフト
            const shiftedTop = BigInt(top) << 32n;
            // endをBigIntに変換し、下位32ビット分だけを取り出す（マスクを適用）
            const lower = BigInt(end) & 0xffffffffn;

            return shiftedTop | lower;
        },
    },
    created: function () {
        this.initialGroup.fullPath = sessionStorage.getItem('trackingGroup');
        if (this.initialGroup.fullPath != null) {
            this.initialGroup.nodeList.push("ROOT-NODE");
            let nodeItems = this.initialGroup.fullPath.split("\\");
            if (nodeItems.length == 1) {
                this.initialGroup.groupName = nodeItems[0];
            } else {
                for (let index = 0 ; index < nodeItems.length ; index++) {
                    if (index == (nodeItems.length - 1)) {
                        this.initialGroup.groupName = nodeItems[index];
                    } else {
                        this.initialGroup.nodeList.push(nodeItems[index]);
                    }
                }
            }
        } else {
            this.initialGroup.nodeList.push("ROOT-NODE");
        }
        this.show = true;
    },
    watch: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}

.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}
.el-tree-node__content {
    height: 40px !important;
}
.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}
.el-tree-node__expand-icon {
    padding: 28px !important;
}

</style>

<style scoped>

.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}
.tree-command-text:hover {
    opacity: 0.7;
}

button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}

.tree-header-left {
    vertical-align: middle;
    padding-top: 12px;
    padding-left: 20px;
    float: left;
}
.tree-header-right {
    text-align : right;
    vertical-align: middle;
    padding-top: 2px;
    padding-bottom: 3px;
    padding-right: 20px;
}

.treetitle {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 42px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
    min-width: 630px;
}
.modal-default-button {
  float: right;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.common-object-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}
.common-object-tree.el-tree {
    width: 100%;
    height: calc(100vh - 105px);
}
.tree-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 20px;
    background-color: #fafafa;
    border-bottom: 1px solid #eee;
}
.tree-controls-label {
    font-size: 12px;
    color: #848991;
}

.tree-item {
  display: inline-flex;
  align-items: center;
}
.tree-text {
  display: inline-block;
  margin-left: 6px;
  line-height: 1.2;
  vertical-align: middle;
}
.tree-name {
  font-size: 12px;
  display: block;
}
.tree-status {
  font-size: 11px;
  color: #848991;
  display: block;
  margin-left: 18px;
}
</style>
